// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fourcolumngrid {
    grid-template-columns: 1.25fr .75fr .75fr .75fr;
}

.threecolumngrid {
    grid-template-columns: 1.25fr .75fr .75fr;
}

.twocolumngrid {
    grid-template-columns: 1.25fr .75fr;
}

.subitemonecolumgrid {
    grid-column: 1/4;
    margin-top: -15px;
    margin-left: 15px;
}

.noshadow {
    box-shadow: none !important;
}

.no-margin-top-bottom {
    margin-top: 10px;
    margin-bottom: 10px;
}



.text-block-450 a {
    font-size: inherit;
}

* {
    /* -webkit-font-smoothing: antialiased; */
    -moz-osx-font-smoothing: grayscale;
}

label {
    display: inline;
}

label.error {
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #da7365 !important;
}

label#hafasamband-error.error {
    position: absolute;
    top: -21px;
    font-size: 16px;
    font-weight: 700;
    color: #da7365;
}

#map {
    object-fit: cover;
    min-width: 100%;
    min-height: 700px;
}

::-webkit-scrollbar {
    /* width:10px; */
}

::-webkit-scrollbar-track {
    -webkit-background: white;
    /* border-radius: 5px; */
}

::-webkit-scrollbar-thumb {
    /* border-radius: 5px; */
    -webkit-background-color: #00aef3;
    /* background-color:#00aef3; */
}

::-webkit-scrollbar-corner {
    /* display: none; */
    /* height: 0px; */
    /* width: 0px; */
}

::selection {
    /* background: #00aef3; */
    /* WebKit/Blink Browsers */
}

::-moz-selection {
    background: #00aef3;
    /* Gecko Browsers */
}

.SCROLLABLE-Div-Class-Name {
    overflow-x: hidden;
}

.forminputkt:focus {
    outline: none;
}

.forminputemail:focus {
    outline: none;
}

.forminputtel:focus {
    outline: none;
}

.text-block-450 p,
.text-block-450 b,
.text-block-450 i {
    margin-bottom: 0;
    padding-bottom: 0;
    color: #474747;
    font-size: 16px;
    line-height: 25px;
    font-weight: 300;
    font-style: normal;
}

.text-block-450 br {
    display: none;
}

.installcostsection {
    background-color: #fff;
    padding-right: 50px;
    padding-left: 50px;
    margin-bottom: -10px;
}

.heading-ic {
    width: 100%;
    font-size: 26px;
    color: #00aef3;
    margin-top: 0;
    margin-bottom: 10px;
}

.checkbox-new-design {
    font-family: Brix, sans-serif;
    color: #12232C;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
}

.checkbox-new-design-link {
    color: #00007C;
    font-family: Brix, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
}



@media screen and (max-width: 991px) {
    .installcostsection {
        padding-right: 30px;
        padding-left: 30px;
    }

    .heading-ic {
        font-size: 20px;
        line-height: 25px;
    }
}

.prices-grid {
    margin-bottom: -10px;
    margin-top: 10px;
    padding-right: 20px;
    padding-left: 30px;
    justify-content: start;
    align-content: stretch;
    flex: 1 1;
    grid-template-columns: 1.05fr .70fr .25fr
}

.pricetextsymbol {
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
    color: black;
}

.normal-link {
    color: #00aef3;
    font-size: 16px;
    line-height: 18px;
}

.text-overflow-fix {
    white-space: nowrap;
    overflow: hidden;
}

.main-product {
    font-weight: bold;
}

.sub-product {
    padding-left: 20px;
    /* Adjust the indent as needed */
}`, "",{"version":3,"sources":["webpack://./src/components/tilbod/QuoteLayout/design.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;AACnD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;;AAIA;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;;;AAIA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;IACT;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC","sourcesContent":[".fourcolumngrid {\n    grid-template-columns: 1.25fr .75fr .75fr .75fr;\n}\n\n.threecolumngrid {\n    grid-template-columns: 1.25fr .75fr .75fr;\n}\n\n.twocolumngrid {\n    grid-template-columns: 1.25fr .75fr;\n}\n\n.subitemonecolumgrid {\n    grid-column: 1/4;\n    margin-top: -15px;\n    margin-left: 15px;\n}\n\n.noshadow {\n    box-shadow: none !important;\n}\n\n.no-margin-top-bottom {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n\n\n.text-block-450 a {\n    font-size: inherit;\n}\n\n* {\n    /* -webkit-font-smoothing: antialiased; */\n    -moz-osx-font-smoothing: grayscale;\n}\n\nlabel {\n    display: inline;\n}\n\nlabel.error {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #da7365 !important;\n}\n\nlabel#hafasamband-error.error {\n    position: absolute;\n    top: -21px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #da7365;\n}\n\n#map {\n    object-fit: cover;\n    min-width: 100%;\n    min-height: 700px;\n}\n\n::-webkit-scrollbar {\n    /* width:10px; */\n}\n\n::-webkit-scrollbar-track {\n    -webkit-background: white;\n    /* border-radius: 5px; */\n}\n\n::-webkit-scrollbar-thumb {\n    /* border-radius: 5px; */\n    -webkit-background-color: #00aef3;\n    /* background-color:#00aef3; */\n}\n\n::-webkit-scrollbar-corner {\n    /* display: none; */\n    /* height: 0px; */\n    /* width: 0px; */\n}\n\n::selection {\n    /* background: #00aef3; */\n    /* WebKit/Blink Browsers */\n}\n\n::-moz-selection {\n    background: #00aef3;\n    /* Gecko Browsers */\n}\n\n.SCROLLABLE-Div-Class-Name {\n    overflow-x: hidden;\n}\n\n.forminputkt:focus {\n    outline: none;\n}\n\n.forminputemail:focus {\n    outline: none;\n}\n\n.forminputtel:focus {\n    outline: none;\n}\n\n.text-block-450 p,\n.text-block-450 b,\n.text-block-450 i {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: #474747;\n    font-size: 16px;\n    line-height: 25px;\n    font-weight: 300;\n    font-style: normal;\n}\n\n.text-block-450 br {\n    display: none;\n}\n\n.installcostsection {\n    background-color: #fff;\n    padding-right: 50px;\n    padding-left: 50px;\n    margin-bottom: -10px;\n}\n\n.heading-ic {\n    width: 100%;\n    font-size: 26px;\n    color: #00aef3;\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n\n.checkbox-new-design {\n    font-family: Brix, sans-serif;\n    color: #12232C;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n}\n\n.checkbox-new-design-link {\n    color: #00007C;\n    font-family: Brix, sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22px;\n}\n\n\n\n@media screen and (max-width: 991px) {\n    .installcostsection {\n        padding-right: 30px;\n        padding-left: 30px;\n    }\n\n    .heading-ic {\n        font-size: 20px;\n        line-height: 25px;\n    }\n}\n\n.prices-grid {\n    margin-bottom: -10px;\n    margin-top: 10px;\n    padding-right: 20px;\n    padding-left: 30px;\n    justify-content: start;\n    align-content: stretch;\n    flex: 1 1;\n    grid-template-columns: 1.05fr .70fr .25fr\n}\n\n.pricetextsymbol {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 300;\n    color: black;\n}\n\n.normal-link {\n    color: #00aef3;\n    font-size: 16px;\n    line-height: 18px;\n}\n\n.text-overflow-fix {\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.main-product {\n    font-weight: bold;\n}\n\n.sub-product {\n    padding-left: 20px;\n    /* Adjust the indent as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
